import { padStart } from 'lodash-es'

export function formatAudioTime(_seconds: number) {
  const seconds = Math.ceil(_seconds)
  const minutes = Math.floor(seconds / 60)
  const restSeconds = Math.ceil(seconds - minutes * 60)
  return `${padStart(`${minutes}`, 2, '0')}:${padStart(`${restSeconds}`, 2, '0')}`
}
